import React from 'react'
import { BeatLoader } from 'react-spinners'

export default function ButtonLoader() {
    return (
        <>
            <div className="d-flex justify-content-center p-1">
                <BeatLoader
                    color="#ffffff"
                    size={11}
                    // margin={3}
                />
            </div>
        </>
    )
}